// extracted by mini-css-extract-plugin
export default {"playerFromEpg":"styles_playerFromEpg__F5bfK","containerPlayer":"styles_containerPlayer__5zxeT"};